import React, { PropTypes } from 'react';
import { ListGroup, ListGroupItem, Collapse } from 'react-bootstrap';
import ShopCategoryList from './ShopCategoryList';
import NewCategoryForm from './NewCategoryForm';

class ShopList extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         shopOpen: -1
      };
      this.changeOpenShop = this.changeOpenShop.bind(this);
   }

   changeOpenShop(shopIndex) {
      this.setState({
         shopOpen: (shopIndex === this.state.shopOpen) ? -1 : shopIndex
      });
   }

   render() {
      const { shops, createNewCategory, createNewSubCategory } = this.props;
      const { shopOpen } = this.state;
      return (
         <ListGroup>
            {shops.map((shop, shopIndex) => (
               <ListGroupItem key={shop.id} >
                  <span onClick={() => this.changeOpenShop(shopIndex)} >{shop.name}</span>
                  <Collapse in={shopOpen === shopIndex} >
                     <div>
                        {shop.categories
                        && <ShopCategoryList
                           categories={shop.categories}
                           shopId={shop.id}
                           createNewSubCategory={createNewSubCategory} />}

                        {(shopOpen === shopIndex)
                        && <NewCategoryForm
                           createNewCategory={createNewCategory}
                           shopId={shop.id} />}
                     </div>
                  </Collapse>
               </ListGroupItem>
            ))}
         </ListGroup>
      );
   }
}

ShopList.propTypes = {
   shops: PropTypes.array.isRequired,
   createNewCategory: PropTypes.func,
   createNewSubCategory: PropTypes.func
};
export default ShopList;



/** WEBPACK FOOTER **
 ** ./src/components/ShopManagement/Shop/ShopList.js
 **/